import React from 'react';
import MSyncScoreFormListItems from './MSyncScoreFormListItems';

export default function MSyncScoreFormList(props) {
  const { scores, listScores } = props;
  return (
    <>
      {listScores?.[0] &&
        listScores.map((item, index) => (
          <MSyncScoreFormListItems
            key={item.NIS}
            index={index}
            scores={scores}
            item={item}
          />
        ))}
      {!listScores?.[0] && (
        <tr>
          <td colSpan='4'>Tidak ada data</td>
        </tr>
      )}
    </>
  );
}
